import { render, staticRenderFns } from "./UnreadMessage.vue?vue&type=template&id=660601bb&scoped=true&"
import script from "./UnreadMessage.vue?vue&type=script&lang=js&"
export * from "./UnreadMessage.vue?vue&type=script&lang=js&"
import style0 from "./UnreadMessage.vue?vue&type=style&index=0&id=660601bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660601bb",
  null
  
)

export default component.exports